import { createFileRoute } from "@tanstack/react-router";
import JsonFormatterPage from "@/pages/JsonFormatterPage";

export const Route = createFileRoute("/tools/json-formatter")({
  component: JsonFormatterPage,
});
